import React from "react";
import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { Building2, LayoutDashboard, LogOut, Shield } from "lucide-react";
import { motion } from "framer-motion";
import { useConsoleAuth } from "@/contexts/ConsoleAuthContext";

const nav = [
  { to: "/console", end: true, label: "Dashboard", icon: LayoutDashboard },
  { to: "/console/companies", end: false, label: "Companies", icon: Building2 },
];

export default function ConsoleShell() {
  const { user, logout } = useConsoleAuth();
  const navigate = useNavigate();
  const location = useLocation();

  async function handleLogout() {
    await logout();
    navigate("/console/login", { replace: true });
  }

  return (
    <div className="console-root min-h-screen text-slate-100">
      <div className="console-ambient" aria-hidden />
      <div className="relative z-10 flex min-h-screen">
        <aside className="flex w-60 shrink-0 flex-col border-r border-white/5 bg-[#070d18]/80 backdrop-blur-xl">
          <div className="border-b border-white/5 px-5 py-6">
            <div className="flex items-center gap-2.5">
              <div className="grid h-9 w-9 place-items-center rounded-xl bg-teal-400/15 ring-1 ring-teal-400/30">
                <Shield className="h-4 w-4 text-teal-300" />
              </div>
              <div>
                <div className="font-[Syne] text-[15px] font-bold tracking-tight text-white">
                  Restaurant ERP
                </div>
                <div className="text-[11px] uppercase tracking-[0.14em] text-teal-300/80">
                  Central Console
                </div>
              </div>
            </div>
          </div>
          <nav className="flex flex-1 flex-col gap-1 p-3">
            {nav.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `flex items-center gap-2.5 rounded-xl px-3 py-2.5 text-[13px] font-medium transition ${
                    isActive
                      ? "bg-teal-400/15 text-teal-200 ring-1 ring-teal-400/25"
                      : "text-slate-400 hover:bg-white/5 hover:text-slate-200"
                  }`
                }
              >
                <item.icon className="h-4 w-4 shrink-0 opacity-80" />
                {item.label}
              </NavLink>
            ))}
          </nav>
          <div className="border-t border-white/5 p-4">
            <div className="mb-3 truncate text-[12px] text-slate-400">{user?.email}</div>
            <button
              type="button"
              onClick={handleLogout}
              className="flex w-full items-center gap-2 rounded-xl px-3 py-2 text-[13px] text-slate-400 transition hover:bg-white/5 hover:text-rose-300"
            >
              <LogOut className="h-4 w-4" />
              Sign out
            </button>
          </div>
        </aside>

        <main className="min-w-0 flex-1 overflow-auto">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.28, ease: [0.22, 1, 0.36, 1] }}
            className="mx-auto max-w-6xl px-6 py-8 lg:px-10"
          >
            <Outlet />
          </motion.div>
        </main>
      </div>
    </div>
  );
}
